import { DeliveryAddressModal } from 'components/address-modal/delivery-address-container';

export default function DeliveryAddressModalPage() {
  return <DeliveryAddressModal />;
}
